import { jsx } from 'react/jsx-runtime';
import { Spinner } from '../../../../spinner/Spinner.mjs';

const LOADING_INDICATOR_SIZE_RECORD = {
  xsmall: 16,
  small: 20,
  default: 22,
  large: 24,
  xlarge: 24
};
function LoadingIndicator({
  color,
  danger = false,
  size = "default",
  variant,
  ...props
}) {
  const indicatorColor = variant === "solid" ? "white" : danger ? "orange" : color;
  return /* @__PURE__ */ jsx(
    Spinner,
    {
      color: indicatorColor,
      size: LOADING_INDICATOR_SIZE_RECORD[size],
      ...props
    }
  );
}

export { LoadingIndicator };
//# sourceMappingURL=LoadingIndicator.mjs.map
